<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Filter {{ utils.getLangTerm('ta-jsa-swms.singular', 'TA/JSA/SWMS') }} Templates</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="filter-content d-flex m-0 py-4 flex-wrap" style="justify-content: space-evenly">

  <ng-container matColumnDef="ppe">
    <div style="padding: 5px !important;">
      <button
        mat-raised-button
        type="button"
        (click)="onSelectPPE()"
        [matBadge]="'' + (dataSource.selected_ppe_ids.length || 'All')"
        class="mx-3 mt-2">
        <mat-icon>headset</mat-icon> PPE
      </button>
    </div>
  </ng-container>

  <ng-container matColumnDef="work_permits">
    <div style="padding: 5px !important;">
      <button
        mat-raised-button
        type="button"
        (click)="onSelectWorkPermits()"
        [matBadge]="'' + (dataSource.selected_work_permit_ids.length || 'All')"
        class="mx-3 mt-2">
        <mat-icon>assignment_ind</mat-icon> Work Permits
      </button>
    </div>
  </ng-container>

  <ng-container matColumnDef="active_archived">
    <div style="padding: 5px !important;">
      <mat-form-field style="width: 150px;" class="mx-3 mt-2" appearance="outline" subscriptSizing="dynamic">
        <mat-label>Active/Archived</mat-label>
        <mat-select
          [(ngModel)]="dataSource.filter_archived"
          placeholder="Active/Archived"
          name="status"
          matTooltip="Toggle between Archived and Active records">
          <mat-option value="false" aria-selected="true">Active</mat-option>
          <mat-option value="true">Archived</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>

</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="d-flex flex-wrap justify-content-center my-2 py-2">

  <ng-container matColumnDef="buttons">
    <div class="p-2">
      <button
        type="button"
        mat-raised-button
        color="primary"
        (click)="onSaveAndClose()">
        <mat-icon>filter_list</mat-icon> Apply Filter
      </button>
    </div>

    <div class="p-2">
      <button
        type="button"
        mat-raised-button
        color="secondary"
        (click)="onClearAndClose()">
        <mat-icon> clear_all</mat-icon> Clear Filter
      </button>
    </div>
  </ng-container>

</mat-dialog-actions>
